// extracted by mini-css-extract-plugin
export default {"button":"Button_button__AWe5L","dark":"Button_dark__2+XI9","dark_theme":"Button_dark_theme__2wwKt","equal":"Button_equal__cKKUM"};